import { makeStyles } from '@material-ui/core/styles';
import { NavigateNext } from '@material-ui/icons';
import { BreadCrumbItem } from '@roc/feature-types';
import { BreadcrumbsNew } from '@roc/ui';
import { observer } from 'mobx-react';
import { useStatusDashboardStore } from '../hooks/useStatusDashboardStore';
import { View } from '../utils/statusDashboardConstants';

const useStyles = makeStyles(() => ({
  root: {
    margin: '0 4px',
  },
}));

// Overview > campaign > recipient; the earlier levels go back to that view
export const StatusDashboardBreadcrumbs = observer(() => {
  const classes = useStyles();
  const { statusDashboardStore: store } = useStatusDashboardStore();

  const titles: Record<View, string> = {
    overview: 'Overview',
    campaign: store.selectedCampaign?.name ?? 'Campaign',
    recipient: store.selectedRecipient?.name ?? 'Recipient',
  };
  const views = store.availableViews.slice(0, store.availableViews.indexOf(store.view) + 1);
  const items: BreadCrumbItem[] = views.map((view, index) => ({
    title: titles[view],
    link: index < views.length - 1,
  }));

  return (
    <BreadcrumbsNew
      className={classes.root}
      breadCrumbItems={items}
      breadCrumbItemClick={index => store.setView(views[index])}
      separator={<NavigateNext fontSize="small" />}
    />
  );
});
